const NotFound = () => (
	<div className="h-screen w-screen bg-canopi-green flex flex-col justify-center content-center flex-wrap">
		<p className="font-dm-sans font-extrabold text-white text-8xl">404</p>
	</div>
)

export default NotFound;